import { HttpMethod, Command } from "~/extensions/api";
export class GetShinjoCommand extends Command {
    constructor(nyukyokeiyakuNo) {
        super(HttpMethod.Get, `keiyaku/${nyukyokeiyakuNo}`);
    }
}
